import {createSelector} from 'reselect';

import Editor from 'Editor';
import {getTablePlugin} from 'notebook/notes/plugins/getTablePlugin';
import {Table} from 'notebook/tables/TableConstants';
import {isPlainTable, isStructuredTable} from 'notebook/TypePredicates';
import {Note, NotePart} from 'notebook/util/NoteUtilConstants';

export function getTableNotePartIndex(note: Note, tableName: string): number | null {
  const index = note.noteParts.findIndex(
    (part) =>
      (part.item && isStructuredTable(part.item) && part.item.name === tableName) ||
      (isPlainTable(part) && part?.table?.name === tableName)
  );
  return index > -1 ? index : null;
}

export function getTableNotePart(note: Note, tableName: string): NotePart | null {
  const notePartIndex = getTableNotePartIndex(note, tableName);
  if (notePartIndex == null || notePartIndex < 0) {
    return null;
  }
  // assert(notePartIndex != null, `Note part index not found for ${tableName}`);
  return note.noteParts[notePartIndex];
}

// TODO(BNCH-126510): This is just the start of building a hydrated table selector
// This does not compute errors yet, it just uses the plugin to generate the table object.
export function createHydratedTableSelector(tableName: string): (note: Note) => Table | null {
  return createSelector([(note: Note) => getTableNotePart(note, tableName)], (notePart) => {
    if (!notePart) {
      return null;
    }
    const plugin = getTablePlugin(notePart);
    return (plugin.getContent.call({} as Editor, notePart) as {table: Table}).table;
  });
}
